<template>
  <div class="slider__card">
    <img src="~@/assets/images/slider-item-imgs/img048.png" class="motivo-logo" alt="MotivO Logo">
    <div class="text-container">
      <text-string label-id="txt1440"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "download-app-card",
  }
</script>
